import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["content", "toggle"]

  connect() {
    this._handleClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener('click', this._handleClickOutside)
  }

  disconnect() {
    document.removeEventListener('click', this._handleClickOutside)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    const content = this.element.querySelector('.c-dropdown__content')
    const isVisible = content.classList.contains('c-dropdown__content--visible')

    this.closeAllDropdowns()

    if (isVisible) {
      this.closeDropdown(content)
    } else {
      this.openDropdown(content)
    }
  }

  openDropdown(content) {
    content.classList.remove('c-dropdown__content--hidden')
    content.classList.add('c-dropdown__content--visible')
    this.setExpanded(content, true)

    const chevron = this.element.querySelector('.custom-chevron')
    if (chevron) {
      chevron.style.transform = 'rotate(180deg)'
    }
  }

  closeDropdown(content) {
    content.classList.remove('c-dropdown__content--visible')
    content.classList.add('c-dropdown__content--hidden')
    this.setExpanded(content, false)

    const chevron = this.element.querySelector('.custom-chevron')
    if (chevron) {
      chevron.style.transform = 'rotate(0deg)'
    }
  }

  setExpanded(content, expanded) {
    if (!content.id) return

    const scope = content.closest('.c-dropdown') || document
    scope.querySelector(`[aria-controls="${content.id}"]`)?.setAttribute('aria-expanded', String(expanded))
  }

  close() {
    const content = this.element.querySelector('.c-dropdown__content')
    if (content) {
      this.closeDropdown(content)
    }
  }

  closeAllDropdowns() {
    const allDropdowns = document.querySelectorAll('.c-dropdown__content--visible')
    allDropdowns.forEach(dropdown => {
      this.closeDropdown(dropdown)
    })
  }

  handleClickOutside(event) {
    const content = this.element.querySelector('.c-dropdown__content')
    if (!content) return

    if (!this.element.contains(event.target)) {
      this.closeDropdown(content)
    }
  }
}
